import Accordion from './accordion';
import { tracker } from '../tracking';
import $ from 'cash-dom';
export default function () {
  try {
    $(() => {
      const faqElement = document.querySelector('.faq__block');

      if (faqElement) {
        console.log('INSTALL ACCORDION');

        new Accordion(faqElement, {
          elementClass: 'faq__item',
          triggerClass: 'faq__headline',
          panelClass: 'faq__body',
          activeClass: 'faq__item--open',
          showMultiple: true,
          onOpen: function (element) {
            //console.log(currentElement);
            tracker.push({event: 'action', id: 'faq', 12: 'oeffnen'});
          },
          onClose: function (element) {
            tracker.push({event: 'action', id: 'faq', 12: 'schliessen'});
          },
        });
      }
    });
  } catch (e) {
    console.error('ACCORDION ERROR', e);
  }
}
